import { render, staticRenderFns } from "./TrUiTitleV2.vue?vue&type=template&id=0fb914da&scoped=true&"
import script from "./TrUiTitleV2.vue?vue&type=script&lang=js&"
export * from "./TrUiTitleV2.vue?vue&type=script&lang=js&"
import style0 from "./TrUiTitleV2.vue?vue&type=style&index=0&id=0fb914da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb914da",
  null
  
)

export default component.exports